import React, {useEffect} from "react";
import {inject, observer} from "mobx-react";
import {Route, Switch} from "react-router-dom";
import Component from "../Components";

function Point(props) {

    let products = [];

    useEffect(() => {

        const fetchData = async () => {

            await props.Data.getPoint();

        }

        fetchData();

    }, [props.Data]);

    useEffect(() => {
        document.title = `Punkt`
    }, [props]);

    const onCheckbox = (e) => {
        props.Data.updatePoint({status: props.Data.point.status == 1 ? 0 : 1});
    }

    const onSelect = (e) => {

        props.Data.point.id_products.push(e.target.value)
        props.Data.updatePoint({id_products: props.Data.point.id_products.join(",")});

    }

    const onRemove = (key) => {

        props.Data.point.id_products.splice(key, 1);
        props.Data.updatePoint({id_products: props.Data.point.id_products.join(",")});

    }

    if (props.Data.loading) {
        return <>Ładowanie</>
    }

    console.log(props.Data.point.products_list);

    return (
        <>

            <h1>Punkt</h1>
            <p className="text-muted">Zarządzanie punktem</p>

            <div className="">
                <h3>Status punktu</h3>
                <div className={`switcher ${props.Data.point.status == 1 ? `switcher--is-active` : ``}`}
                     onClick={onCheckbox}>
                    <div className="switcher__button"></div>
                </div>
            </div>

            <div className="mt">
                <h3>Zablokowane produkty</h3>
                <select className={`form-control w100`} onChange={onSelect}>
                    {
                        props.Data.point.products && props.Data.point.products.map(item => <option key={item.id}
                                                                                                   value={item.id}>{item.name}</option>)
                    }

                </select>
            </div>

            <div className="mt">
                {
                    props.Data.point.products_list.map((item, key) => (
                            <div className={"card__list"} key={item.id}>
                                <span>{item.name}</span>
                                <button className={`btn btn--primary`} type={`button`} onClick={() => onRemove(key)}>
                                    <i className="las la-trash"></i></button>
                            </div>
                        )
                    )
                }
            </div>

        </>

    );
}

export default inject('Data')(observer(Point))
